export default "__VITE_ASSET__3729edcc__"